module.exports = __webpack_public_path__ + "img/DE00863.ee154089.png";